import { render, staticRenderFns } from "./SkipNavigation.vue?vue&type=template&id=ed77f052"
import script from "./SkipNavigation.vue?vue&type=script&lang=js"
export * from "./SkipNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports